import { Link } from "react-router-dom";
import {
  primaryDarkColor,
  blackColor,
  hexToRgb,
  primaryColor,
} from "assets/jss/xrs.js";
import { makeStyles } from "tss-react/mui";
import Badge from "@mui/material/Badge";
import MailIcon from "@mui/icons-material/Mail";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import Icon from "@mui/material/Icon";
import Button from "components/CustomButtons/Button.js";
import React, { useContext, useRef } from "react";
import Context from "../../utils/context";
import AccountItem from "./AccountItem.js";
import AccountCircle from "@mui/icons-material/AccountBox";

import landingPageStyle from "assets/jss/xrs/views/landingPageStyle.js";
import { useNavigate } from "react-router-dom";

import * as URLS from "../../utils/XRSAPIs";
import { useBeforeunload } from "react-beforeunload";
import * as ACTIONS from "../../store/actions/actions";
import { useDispatch, useSelector } from "react-redux";
import { ApiErrorHandler } from "utils/apiErrorHandler";
import LinearProgress from "@mui/material/LinearProgress";

const isMobile =
  /Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent) ||
  window.matchMedia("(max-width: 768px)").matches;
import { getSiteDetailsActions } from "store/redux/redux-actions/redux_actions";

const drawerWidth = 150;

const useStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
    padding: "0px",
    paddingBottom: "20px",
  },
  rootMultiple: {
    display: "flex",
    padding: "0px",
  },

  "@keyframes burgerTransition": {
    marginLeft: theme.spacing(1.5),
    marginRight: theme.spacing(3),
    from: {
      color: primaryDarkColor[0],
      width: 50,
      height: 50,
      boxShadow:
        "0 14px 26px -12px rgba(" +
        hexToRgb(primaryDarkColor[0]) +
        ", 0.42), 0 4px 23px 0px rgba(" +
        hexToRgb(blackColor) +
        ", 0.12), 0 8px 10px -5px rgba(" +
        hexToRgb(primaryDarkColor[0]) +
        ", 0.2)",
    },
    to: { color: "black", width: 22, height: 22, boxShadow: "none" },
  },
  menuButton: {
    animationName: "$burgerTransition",
    animationDuration: "1s",
    animationDelay: "0s",
    marginLeft: theme.spacing(1.5),
    marginRight: theme.spacing(3),
  },
  menuLogo: {
    marginLeft: theme.spacing(1.5),
    marginRight: theme.spacing(3),
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    border: "none",
  },
  DisplayY: {
    textAlign: "center",
    fontSize: 13,
    fontWeight: 400,
    marginTop: 1,
  },
  DisplayN: {
    textAlign: "center",
    fontSize: 13,
    fontWeight: 400,
    marginTop: 1,
    display: "none",
  },
  drawerPass: {
    width: drawerWidth,
    flexShrink: 0,
    border: "none",
  },

  standardButton: {
    backgroundColor: primaryColor[7],
    color: "black",
    margin: "8px 0",
    border: "none",
    cursor: "pointer",
    opacity: "1",
    borderRadius: 0,
    width: 10,
    zIndex: 999999,
  },
  accountButton: {
    cursor: "pointer",
    opacity: "1",
    borderRadius: 0,
    zIndex: 999999,
  },
  notificationButton: {
    cursor: "pointer",
    opacity: "1",
    borderRadius: 0,
    width: 50,
    zIndex: 999999,
  },
  drawerPaper: {
    height: "-webkit-fill-available",
    zIndex: 999999,
    width: drawerWidth,
    top: 56,
    border: 0,
    paddingTop: 30,
    backgroundColor: primaryColor[7],
  },
  linkButton: {
    padding: "25px 25px",
    width: 35,
    textAlign: "center",
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
  },
  title: {
    textAlign: "center",
    fontSize: 19,
    fontWeight: 400,
    marginTop: 40,
    color: "white",
  },
  textCenter: {
    textAlign: "center",
    fontSize: 13,
    fontWeight: 400,
    marginTop: 1,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),

    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },
  username: {
    fontSize: 14,
    width: "fit-content",
    textTransform: "capitalize",
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
  Right: {
    marginLeft: "auto",
    marginRight: 20,
    textAlign: "right",
  },
}));

const useStyles2 = makeStyles()(() => landingPageStyle);
export default function HeaderLoggedIN(props) {
  const { classes } = useStyles();
  const { classes: classes2, cx } = useStyles2();
  const navigate = useNavigate();

  const drawers = useSelector((state) => state.GetSiteDetailsReducer.drawers);

  const updateDrawers = (values) => {
    dispatch(getSiteDetailsActions.setDrawerState(values));
  };

  const [accounts, setAccounts] = React.useState([]);
  const dispatch = useDispatch();
  const logo = useSelector((state) => state.GetSiteDetailsReducer.logoimageurl);
  const loading = useSelector((state) => state.ApiCallsReducer.loading);
  const [menuAnimation, setMenuAnimation] = React.useState(false);
  React.useEffect(() => {
    setMenuAnimation(true);
  }, []);

  const stateAccounts = useSelector((state) => state.AccountsReducer.accounts);

  const stateSelectedAccount = useSelector(
    (state) => state.SelectedAccountsReducer.account,
  );
  const stateCustomer = useSelector((state) => state.CustomerReducer.customer);
  const stateMenu = useSelector((state) => state.MenuReducer.menu);
  const numOfAccounts = useSelector(
    (state) => state.AccountsReducer.numOfAccounts,
  );
  const [buttons, setButtons] = React.useState([]);
  const page = props.page;

  useBeforeunload(() => {
    handleLogOut();
  });
  const ref = useRef();
  useOnClickOutside(ref, () => {
    resetDrawerState();
  });

  React.useEffect(() => {
    if (stateMenu != null && stateMenu != "no items") {
      var tmpbuttons = stateMenu.accountMenus.find(
        (x) => x.recNo == stateSelectedAccount.recno,
      );
      if (tmpbuttons != null) {
        setButtons(tmpbuttons.menuButtons);
      } else {
        setButtons([]);
      }
    }
  }, [stateSelectedAccount]);

  React.useEffect(() => {
    if (stateSelectedAccount == "NoAccount") {
      fetch(URLS.GetWelcomeDetails, {
        method: "GET",
        headers: { Authorization: "Bearer " + token },
      })
        .then((res) => {
          if (res.status == 200 || res.status == 201) {
            return res.json();
          } else {
            ApiErrorHandler("Get Welcome Details", res, context);
            throw Error("");
          }
        })
        .then((data) => {
          if (data.activeAccounts.length == 1) {
            if (data.activeAccounts[0].planinplace == "Y") {
              setPlanText("Amend");
            } else {
              setPlanText("Create");
            }
          }
        })

        .catch((error) => {
          if (error.message == "") {
          } else {
            ApiErrorHandler("Get Welcome Details", error, context);
          }
        });
    } else {
      if (stateSelectedAccount.planinplace == "Y") {
        setPlanText("Amend");
      } else {
        setPlanText("Create");
      }
    }
  }, []);

  React.useEffect(() => {
    let contextDrawers = {
      open: false,
      openSecond: false,
      openThird: false,
      lastOpenedDrawer: "drawerOne", // set the last opened drawer to drawerOne when opening
    };
    // if (isMobile) {
    //   if (page == "welcome") contextDrawers.open = true;
    //   if (page == "viewAccount") contextDrawers.openSecond = true;
    // } else {

    if (!context.stateTwo) {
      contextDrawers.openSecond = false;
    } else {
      contextDrawers.openSecond = context.stateTwo;
      contextDrawers.lastOpenedDrawer = "drawerTwo";
    }
    if (!context.stateThree) {
      contextDrawers.openThird = false;
    } else {
      contextDrawers.openThird = context.stateThree;
      contextDrawers.lastOpenedDrawer = "drawerTree";
    }
    if (!context.stateOne) {
      contextDrawers.open = false;
    } else {
      contextDrawers.open = context.stateOne;
      contextDrawers.lastOpenedDrawer = "drawerOne";
    }
    // }
    if (isMobile) {
      if (page == "welcome" && drawers.lastOpenedDrawer == "mobileOne")
        contextDrawers.open = true;
      else if (contextDrawers.lastOpenedDrawer == "drawerTwo")
        contextDrawers.openSecond = true;
      else if (
        contextDrawers.lastOpenedDrawer == "drawerTree" &&
        page == "viewAccount"
      )
        contextDrawers.openThird = false;
      else {
        contextDrawers.open = false;
        contextDrawers.openSecond = false;
        contextDrawers.openThird = false;
      }
    }
    updateDrawers(contextDrawers);
    var arr = [];

    if (stateAccounts == "NoAccount") {
      Object.keys(stateAccounts).forEach(function (key) {
        arr.push(stateAccounts[key]);
      });
      setAccounts(arr);
    } else {
      arr = Object.values(stateAccounts);
      setAccounts(arr);
    }
  }, []);
  const resetDrawerState = (fromButton = false) => {
    debugger;
    if (isMobile) {
      updateDrawers({
        open: false,
        openSecond: false,
        openThird: false,
        lastOpenedDrawer: drawers.lastOpenedDrawer, // set the last opened drawer to drawerOne when opening
      });
      context.dispatchDrawer(false);

      context.dispatchDrawerTwo(false);
      context.dispatchDrawerThree(false);
      context.dispatchDrawerOne(false);
    } else {
      debugger;
      if (fromButton === true) {
        updateDrawers({
          open: false,
          openSecond: false,
          openThird: false,
          lastOpenedDrawer: drawers.lastOpenedDrawer, // set the last opened drawer to drawerOne when opening
        });
        context.dispatchDrawer(false);

        context.dispatchDrawerTwo(false);
        context.dispatchDrawerThree(false);
        context.dispatchDrawerOne(false);
      } else {
        updateDrawers({
          open: true,
          openSecond: false,
          openThird: false,
          lastOpenedDrawer: drawers.lastOpenedDrawer, // set the last opened drawer to drawerOne when opening
        });
        context.dispatchDrawerOne(true);
      }
    }
  };
  const handleDrawerOpen = (fromMenubutton) => {
    if (drawers.open || drawers.openSecond || drawers.openThird) {
      resetDrawerState(fromMenubutton);
    } else {
      context.dispatchDrawer(true);
      if (drawers.lastOpenedDrawer === "drawerOne" || numOfAccounts == 1) {
        handleFirtstDrawerOpen();
      } else if (drawers.lastOpenedDrawer === "drawerTwo") {
        handleSecondDrawerOpen();
      } else if (drawers.lastOpenedDrawer === "drawerTree") {
        handleThirdDrawerOpen();
      }
    }
  };
  const handleFirtstDrawerOpen = (fromBackButton = false) => {
    if (numOfAccounts > 1) {
      dispatch(ACTIONS.set_selectedAccount("NoAccount"));
    } else {
      dispatch(ACTIONS.set_selectedAccount(accounts[0]));
    }

    updateDrawers({
      open: true,
      openSecond: false,
      openThird: false,
      lastOpenedDrawer: fromBackButton ? "mobileOne" : "drawerOne", // set the last opened drawer to drawerOne when opening
    });
    context.dispatchDrawer(true);
    context.dispatchDrawerTwo(false);
    context.dispatchDrawerThree(false);
    context.dispatchDrawerOne(true);
    if (numOfAccounts > 1 && fromBackButton) {
      navigate(`/welcome`);
    }
  };
  const handleSecondDrawerOpen = () => {
    var arr = Object.values(stateAccounts);
    setAccounts(arr);

    updateDrawers({
      open: false,
      openSecond: true,
      openThird: false,
      lastOpenedDrawer: "drawerTwo", // set the last opened drawer to drawerTwo when opening
    });
    context.dispatchDrawer(true);

    context.dispatchDrawerTwo(true);
    context.dispatchDrawerThree(false);
    context.dispatchDrawerOne(false);
    if (stateSelectedAccount == "NoAccount") {
      dispatch(ACTIONS.set_selectedAccount(accounts[0]));

      navigate(`/viewAccount`);
    }
  };
  const handleThirdDrawerOpen = (e) => {
    updateDrawers({
      open: false,
      openSecond: false,
      openThird: true,
      lastOpenedDrawer: "drawerTree", // set the last opened drawer to drawerTwo when opening
    });
    context.dispatchDrawer(true);

    context.dispatchDrawerTwo(false);
    context.dispatchDrawerThree(true);
    context.dispatchDrawerOne(false);
  };

  const handlebacktosecond = () => {
    updateDrawers({
      openThird: false,
      openSecond: true,
      open: false,
      lastOpenedDrawer: "drawerTwo", // set the last opened drawer to drawerTwo when going back
    });
    context.dispatchDrawerTwo(true);
    context.dispatchDrawerThree(false);
    context.dispatchDrawerOne(false);
  };

  const handleLogOut = () => {
    context.authObj.logout(navigate);
  };

  const token = sessionStorage.getItem("access_token");

  const handleChangePassword = () => {
    navigate("/changePassword");
  };
  const handleChangePin = () => {
    navigate("/changePin");
  };
  const handlereadMessages = () => {
    navigate("/messages");
  };

  const context = useContext(Context);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [planText, setPlanText] = React.useState("");
  const openp = Boolean(anchorEl);
  const budgetPageButton = buttons.find((x) => x.buttonName === "budgetPage");

  const budgetPageButtonisVisible =
    budgetPageButton && budgetPageButton.buttonVisible === "Y";

  const budgetPageButtonclassName = budgetPageButtonisVisible
    ? classes.DisplayY
    : classes.DisplayN;

  if (numOfAccounts == 1) {
    return (
      <div ref={ref} className={classes.root}>
        <CssBaseline />

        <AppBar
          elevation={0}
          position="fixed"
          className={classes2.headerLoggedInColor}
        >
          {loading == true ? <LinearProgress /> : null}

          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={(e) => {
                e.preventDefault(); // Optional, if needed
                handleDrawerOpen(true);
              }}
              className={classes.standardButton}
              edge="end"
              height="40"
            >
              <MenuIcon
                sx={{ marginRight: 5 }}
                className={
                  isMobile
                    ? menuAnimation
                      ? classes.menuButton
                      : classes.menuLogo
                    : classes.menuLogo
                }
              />
            </IconButton>

            {logo === "" ? null : (
              <img
                className={classes.menuLogo}
                src={logo}
                alt="..."
                height="45px"
              />
            )}

            <section className={classes.Right}>
              {stateCustomer.showmsginbox !== "Y" ? null : (
                <IconButton
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  sx={{ color: primaryColor[20] }}
                  onClick={handlereadMessages}
                  className={classes.notificationButton}
                >
                  <Badge
                    badgeContent={stateCustomer.unreadmessages}
                    sx={{ color: primaryColor[20] }}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "left",
                    }}
                  >
                    <MailIcon />
                  </Badge>
                </IconButton>
              )}

              <IconButton
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                sx={{ color: primaryColor[20] }}
                onClick={handleMenu}
                className={classes.accountButton}
              >
                <Badge
                  sx={{ color: primaryColor[20] }}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                >
                  <AccountCircle />
                </Badge>
                <span className={classes.username}>
                  {" "}
                  {stateCustomer.cufname
                    ? stateCustomer.cufname
                    : stateCustomer.culname.toLowerCase()}
                </span>
              </IconButton>

              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={openp}
                onClose={handleClose}
              >
                {/* <MenuItem onClick={handlereadMessages}>
                  Messages ({stateCustomer.unreadmessages}){" "}
                </MenuItem> */}
                <MenuItem onClick={handleLogOut}>Log Out</MenuItem>
                <MenuItem onClick={handleChangePassword}>
                  Change Password
                </MenuItem>
                <MenuItem onClick={handleChangePin}>Change Pin</MenuItem>
              </Menu>
            </section>
          </Toolbar>
        </AppBar>

        <Drawer
          id="Drawer"
          className={classes.drawer}
          variant="persistent"
          anchor="left"
          open={drawers.open}
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          <div onClick={resetDrawerState} className={classes.textCenter}>
            <Button
              component={Link}
              to="/welcome"
              className={classes.linkButton}
              color={page == "welcome" ? "primary" : "linkedin"}
            >
              <Icon className="fa fa-handshake-o" />
            </Button>
          </div>

          <h4 className={classes.textCenter}>Welcome</h4>
          {buttons.length === 0 ? null : (
            <>
              {" "}
              {renderButton(
                "viewOffer",
                "/viewoffer",
                "fa fa-suitcase",
                buttons,
                classes,
                page,
                resetDrawerState,
              )}
              {renderButton(
                "createPayment",
                "/createPayment",
                "fa fa-credit-card",
                buttons,
                classes,
                page,
                resetDrawerState,
              )}
              {renderButton(
                "payNow",
                "/payNow",
                "fa fa-credit-card-alt",
                buttons,
                classes,
                page,
                resetDrawerState,
              )}
              {renderButton(
                "viewAccount",
                "/viewAccount",
                "fa fa-user-circle-o",
                buttons,
                classes,
                page,
                resetDrawerState,
              )}
              {renderButton(
                "budgetPage",
                "/budgetPage",
                "fa fa-handshake-o",
                buttons,
                classes,
                page,
                resetDrawerState,
              )}
              {renderButton(
                "faq",
                "/faq",
                "fa fa-question-circle-o",
                buttons,
                classes,
                page,
                resetDrawerState,
              )}
              {renderButton(
                "requestcallback-page",
                "/requestcallback-page",
                "fa fa-phone",
                buttons,
                classes,
                page,
                resetDrawerState,
              )}
              {renderUrlButtons(buttons, classes)}
            </>
          )}
        </Drawer>
      </div>
    );
  } else if (numOfAccounts > 1) {
    return (
      <div className={classes.rootMultiple}>
        <CssBaseline />
        <AppBar
          elevation={0}
          position="fixed"
          className={classes2.headerLoggedInColor}
        >
          {loading == true ? <LinearProgress /> : null}
          <Toolbar>
            <div width="150">
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={(e) => {
                  e.preventDefault(); // Optional, if needed
                  handleDrawerOpen(true);
                }}
                className={classes.standardButton}
              >
                <MenuIcon
                  className={
                    isMobile
                      ? menuAnimation
                        ? classes.menuButton
                        : classes.menuLogo
                      : classes.menuLogo
                  }
                />
              </IconButton>
            </div>

            {logo === "" ? null : (
              <img
                className={classes.menuLogo}
                src={logo}
                alt="..."
                height="45px"
              />
            )}
            <section className={classes.Right}>
              {stateCustomer.showmsginbox !== "Y" ? null : (
                <IconButton
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  sx={{ color: primaryColor[20] }}
                  onClick={handlereadMessages}
                  className={classes.notificationButton}
                >
                  <Badge
                    badgeContent={stateCustomer.unreadmessages}
                    sx={{ color: primaryColor[20] }}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "left",
                    }}
                  >
                    <MailIcon />
                  </Badge>
                </IconButton>
              )}
              <IconButton
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="primary"
                onClick={handleMenu}
                className={classes.accountButton}
              >
                <AccountCircle />
                <span className={classes.username}>
                  {" "}
                  {stateCustomer.cufname
                    ? stateCustomer.cufname
                    : stateCustomer.culname.toLowerCase()}
                </span>
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={openp}
                onClose={handleClose}
              >
                <MenuItem onClick={handleLogOut}>Log Out</MenuItem>
                <MenuItem onClick={handleChangePassword}>
                  Change Password
                </MenuItem>
                <MenuItem onClick={handleChangePin}>Change Pin</MenuItem>
              </Menu>
            </section>
          </Toolbar>
        </AppBar>

        <Drawer
          className={classes.drawer}
          variant="persistent"
          anchor="left"
          open={drawers.open}
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          <div className={classes.textCenter}>
            <Button
              component={Link}
              to="/welcome"
              className={classes.linkButton}
              color={page == "welcome" ? "primary" : "linkedin"}
            >
              <Icon className="fa fa-handshake-o" />
            </Button>
          </div>

          <h4 className={classes.textCenter}>Welcome</h4>

          <div className={classes.textCenter}>
            <Button
              onClick={handleSecondDrawerOpen}
              className={classes.linkButton}
              color={page == "accounts" ? "primary" : "linkedin"}
            >
              <Icon className="fa fa-users" />
            </Button>
          </div>

          <h4 className={classes.textCenter}>Accounts ({numOfAccounts})</h4>

          <div className={budgetPageButtonclassName}>
            <Button
              component={Link}
              to="/budgetPage"
              className={classes.linkButton}
              color={page == "budgetPage" ? "primary" : ""}
            >
              <Icon className="fa fa-handshake-o" />
            </Button>
            <h4 className={classes.textCenter}>Buget Planner</h4>
          </div>

          <div className={classes.textCenter}>
            <Button
              className={classes.linkButton}
              component={Link}
              to="/faq"
              color={page == "Faq" ? "primary" : "linkedin"}
            >
              <Icon className="fa fa-question-circle-o" />
            </Button>
          </div>
          <h4 className={classes.textCenter}>Faq</h4>
        </Drawer>
        <Drawer
          key="drawer3"
          className={classes.drawer}
          variant="persistent"
          anchor="left"
          open={drawers.openSecond}
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          {accounts.map((account, index) => (
            <AccountItem
              key={index}
              onClick={handleThirdDrawerOpen}
              account={account}
            />
          ))}

          <div className={classes.textCenter}>
            <Button
              onClick={() => handleFirtstDrawerOpen(true)}
              className={classes.linkButton}
              color={page == "back" ? "primary" : "linkedin"}
            >
              <Icon className="fa fa-chevron-left" />
            </Button>
          </div>

          <h4 className={classes.textCenter}>back</h4>
        </Drawer>
        <Drawer
          className={classes.drawer}
          variant="persistent"
          anchor="left"
          open={drawers.openThird}
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          {buttons.length === 0 ? null : (
            <>
              {" "}
              {renderButton(
                "viewOffer",
                "/viewoffer",
                "fa fa-suitcase",
                buttons,
                classes,
                page,
              )}
              {renderButton(
                "createPayment",
                "/createPayment",
                "fa fa-credit-card",
                buttons,
                classes,
                page,
              )}
              {renderButton(
                "payNow",
                "/payNow",
                "fa fa-credit-card-alt",
                buttons,
                classes,
                page,
              )}
              {renderButton(
                "viewAccount",
                "/viewAccount",
                "fa fa-user-circle-o",
                buttons,
                classes,
                page,
              )}
              {renderButton(
                "budgetPage",
                "/budgetPage",
                "fa fa-handshake-o",
                buttons,
                classes,
                page,
              )}
              {renderButton(
                "faq",
                "/faq",
                "fa fa-question-circle-o",
                buttons,
                classes,
                page,
              )}
              {renderButton(
                "requestcallback-page",
                "/requestcallback-page",
                "fa fa-phone",
                buttons,
                classes,
                page,
              )}
              {renderUrlButtons(buttons, classes)}
            </>
          )}

          <div className={classes.textCenter}>
            <Button
              onClick={handlebacktosecond}
              className={classes.linkButton}
              color={page == "back" ? "primary" : "linkedin"}
            >
              <Icon className="fa fa-chevron-left" />
            </Button>
          </div>
          <h4 className={classes.textCenter}>back</h4>
        </Drawer>
      </div>
    );
  } else if (numOfAccounts == 0) {
    return "loading...";
  }
}

function useOnClickOutside(ref, handler) {
  React.useEffect(() => {
    if (isMobile) {
      const listener = (event) => {
        // Do nothing if clicking ref's element or descendent elements
        if (!ref.current || ref.current.contains(event.target)) {
          return;
        }
        handler(event);
      };
      document.addEventListener("mousedown", listener);
      document.addEventListener("touchstart", listener);
      return () => {
        document.removeEventListener("mousedown", listener);
        document.removeEventListener("touchstart", listener);
      };

      // Add ref and handler to effect dependencies
      // It's worth noting that because passed in handler is a new ...
      // ... function on every render that will cause this effect ...
      // ... callback/cleanup to run every render. It's not a big deal ...
      // ... but to optimize you can wrap handler in useCallback before ...
      // ... passing it into this hook.
    }
  }, [ref, handler]);
}

function renderButton(name, path, icon, buttons, classes, page, handleClose) {
  const button = buttons.find((x) => x.buttonName === name);
  // console.log(button.buttonName);
  // console.log(button.buttonVisible);

  if (!button || button.buttonVisible !== "Y") {
    return null;
  }
  const openInNewTab = button.buttonFrameURL;

  return (
    <>
      <div onClick={handleClose} className={classes[textClass(button)]}>
        <Button
          component={openInNewTab ? "a" : Link}
          href={openInNewTab ? path : undefined}
          to={openInNewTab ? undefined : path}
          target={openInNewTab ? "_blank" : undefined}
          rel={openInNewTab ? "noopener noreferrer" : undefined}
          className={classes.linkButton}
          color={page === button.buttonName ? "primary" : "linkedin"}
        >
          <Icon className={icon} />
        </Button>
      </div>
      <h4 className={classes[textClass(button)]}>{button.buttonText}</h4>
    </>
  );
}
function renderUrlButtons(buttons, classes) {
  const fillteredButtons = buttons.filter(
    (x) => x.buttonFrameURL && x.buttonVisible == "Y",
  );
  // console.log(button.buttonName);
  // console.log(button.buttonVisible);

  return (
    <>
      {fillteredButtons.map((el) => (
        <div key={el.buttonText + "drawer-button"}>
          <div className={classes[textClass(el)]}>
            <Button
              component={"a"}
              href={el.buttonFrameURL}
              target="_blank"
              rel={"noopener noreferrer"}
              className={classes.linkButton}
              color={"linkedin"}
            >
              <Icon className={"fa fa-suitcase"} />
            </Button>
          </div>
          <h4 className={classes[textClass(el)]}>{el.buttonText}</h4>
        </div>
      ))}
    </>
  );
}
function textClass(button) {
  return button.buttonVisible === "Y" ? "DisplayY" : "DisplayN";
}
